import React from "react";
import { Activity, ShieldCheck, TrendingUp } from "lucide-react";
import { Button } from "@/components/ui/button";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const signIn = () => {
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex bg-[#0b1120] text-white">
      <div className="hidden lg:block lg:w-1/2 relative">
        <img src="https://images.pexels.com/photos/16571735/pexels-photo-16571735.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Clinic" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0b1120]/70" />
        <div className="relative z-10 h-full flex flex-col justify-between p-12">
          <div className="text-[#C9A24B] font-heading text-xl tracking-wide">Youngness Centre</div>
          <div>
            <h1 className="font-heading text-4xl font-light leading-tight">OT Technician & Nursing<br />Intelligence CRM</h1>
            <p className="text-slate-300 mt-4 max-w-md">Be the invisible hand that makes every surgery safe, smooth, and on time.</p>
            <div className="flex gap-6 mt-8 text-sm text-slate-300">
              <span className="flex items-center gap-2"><ShieldCheck size={18} className="text-emerald-400" /> Zero-error tracking</span>
              <span className="flex items-center gap-2"><TrendingUp size={18} className="text-[#C9A24B]" /> Cross-sell incentives</span>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-11 h-11 rounded-lg bg-[#C9A24B] flex items-center justify-center text-[#0b1120]"><Activity /></div>
            <div>
              <div className="font-heading text-lg">Youngness OT CRM</div>
              <div className="text-xs text-slate-400">by Dr. Awish</div>
            </div>
          </div>
          <h2 className="font-heading text-2xl font-light mb-2">Welcome back</h2>
          <p className="text-slate-400 text-sm mb-8">Sign in with your Google account to access the OT team dashboard across all three branches.</p>
          <Button data-testid="google-signin-btn" onClick={signIn}
            className="w-full bg-white text-[#0b1120] hover:bg-slate-200 font-semibold h-12">
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="g" className="w-5 h-5 mr-2" />
            Continue with Google
          </Button>
          <p className="text-xs text-slate-600 mt-6">Sarita Vihar · Mathura · Jaipur</p>
        </div>
      </div>
    </div>
  );
}
